import styles from './LotteryGameRoomBodyLostConnection.module.scss';

import { Typography } from '@shared/Typography';

export const LotteryGameRoomBodyLostConnection = ({
  gameStarted,
}: {
  gameStarted: boolean;
}) => {
  return (
    <div className={styles.lcContainer}>
      <Typography component="h0" className={styles.lcGoldText}>
        CONNECTION LOST
      </Typography>
      <Typography component="h2">
        {gameStarted
          ? "Don't worry the game continues. You will see results as soon as game is finished"
          : "Game hasn't started. Balance refunded"}
      </Typography>
    </div>
  );
};
